import type { ListResponse } from '~/@types'
import { AppApi } from '~/App/utils/api'
import { API_URL } from '~/constants/environment'

import type {
  ChatThread,
  ChatThreadEvent,
  ChatThreadsPayload,
  SaveChatThreadEvent,
} from '../@types'

const chatThreadsApi = new AppApi(API_URL, 'customers/chat_threads')
const chatThreadEventsApi = new AppApi(API_URL, 'customers/chat_thread_events')

export const fetchChatThreads = ({ pagination, sort, serializer }: ChatThreadsPayload) => {
  return chatThreadsApi.get<ListResponse<ChatThread>>({
    query: {
      pagination,
      sort,
      serializer,
    },
  })
}

export const createChatThreadEvent = async (data: SaveChatThreadEvent) => {
  return (
    await chatThreadEventsApi.post<{ data: ChatThreadEvent }>({
      body: { data },
    })
  ).data
}
